"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var ProductLayoutProvider_1 = require("../ProductLayoutProvider");
exports.fetchConfig = {
    headers: { 'Content-Type': 'application/json' },
    method: 'POST',
};
exports.customProductLayouts = {
    defaultReco: __assign(__assign({}, ProductLayoutProvider_1.productLayoutConfigDefault), { componentVisible: __assign(__assign({}, ProductLayoutProvider_1.productLayoutConfigDefault.componentVisible), { patches: false }) }),
};
exports.sliderConfig = function (cardLayout, lazyLoad) { return ({
    styleType: cardLayout ? 'type2' : 'default',
    lazyLoad: lazyLoad,
    slidesToShow: 1.5,
    slidesToScroll: 1,
    responsive: [
        { breakpoint: 300, settings: { slidesToShow: 2.5, slidesToScroll: 3 } },
        { breakpoint: 480, settings: { slidesToShow: 3.5, slidesToScroll: 3 } },
        { breakpoint: 700, settings: { slidesToShow: 4.5, slidesToScroll: 4 } },
        { breakpoint: 960, settings: { slidesToShow: 5.5, slidesToScroll: 5 } },
        { breakpoint: 1200, settings: { slidesToShow: 6.5, slidesToScroll: 6 } },
        { breakpoint: 1300, settings: { slidesToShow: 7.5, slidesToScroll: 6 } },
        { breakpoint: 1500, settings: { slidesToShow: 8.5, slidesToScroll: 8 } },
    ],
}); };
//# sourceMappingURL=config.js.map